const OBJECTS = new Map();

export default class Ressources {

	static set(name, value) {

		OBJECTS.set(name, value)
		
	}

	static get(value) {
	   
	   return OBJECTS.get(value);
	}
}


// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/ressources.js